import { Body } from "sunday-component";
import styled from "styled-components";

export const MainMenuContainer = styled.div``;

export const UpDownIcon = styled.span`
  padding-left: 1rem;
  font-size: 14px;
`;

export const MainMenuUl = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const MainMenuLi = styled.li`
  margin-right: 32px;
  :last-of-type {
    margin-right: 0px;
  }
`;

export const MainMenuLink = styled.a`
  color: #2b2b2b;
  :hover {
    color: #ff875e;
  }
`;

export const MainMenuBody = styled(Body)`
  :hover {
    color: #ff875e;
  }
`;

export const MainMenuText = styled.div`
  cursor: pointer;
`;
